import type { IColumnsPickerLiteProps } from "@similarweb/ui-components";
import { ColumnsPickerLite } from "@similarweb/ui-components";
import { SearchInput } from "@similarweb/ui-components";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import type { FunctionComponent } from "react";
import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";
import { allTrackers } from "app/services/track/track";

const DownloadExcelContainer = styled.span`
    margin: 0 8px 0 16px;
`;

const Right = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 0;
    height: 40px;
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;

export const AdNetworksTableTop: FunctionComponent<any> = (props) => {
    const {
        isLoadingData,
        tableColumns,
        onClickToggleColumns,
        downloadExcelPermitted,
        excelLink,
        searchValue,
        onChange,
        a2d,
        i18n,
    } = props;

    const getColumnsPickerLiteProps = (): Omit<IColumnsPickerLiteProps, "translations"> => {
        const columns = tableColumns.reduce((res, col, index) => {
            if (!col.fixed) {
                return [
                    ...res,
                    {
                        key: index.toString(),
                        displayName: col.displayName,
                        visible: col.visible,
                    },
                ];
            }
            return res;
        }, []);
        return {
            columns,
            onColumnToggle,
            onPickerToggle: () => null,
            maxHeight: 264,
            width: "auto",
        };
    };
    const onColumnToggle = (key) => {
        if (tableColumns[key].visible) {
            allTrackers.dispatchTrackEvent(
                "Drop Down",
                "remove",
                `Table Columns/${tableColumns[key].displayName || ""}`,
            );
        } else {
            allTrackers.dispatchTrackEvent("Drop Down", "add", `Table Columns/${tableColumns[key].displayName || ""}`);
        }
        onClickToggleColumns(parseInt(key, 10));
    };
    const excelDownloadUrl = downloadExcelPermitted ? excelLink : "";
    const trackExcelDownload = () => {
        allTrackers.dispatchTrackEvent("Download", "submit-ok", " Table/Excel");
    };
    return !isLoadingData ? (
        <SearchContainer>
            <SearchInput
                disableClear={true}
                defaultValue={searchValue}
                debounce={400}
                onChange={onChange}
                placeholder={i18n("forms.search.placeholder")}
            />
            <Right>
                <FlexRow>
                    <DownloadExcelContainer>
                        <DownloadButtonMenu
                            Excel={true}
                            downloadUrl={excelDownloadUrl}
                            exportFunction={trackExcelDownload}
                            excelLocked={!downloadExcelPermitted}
                        />
                    </DownloadExcelContainer>
                    <div>
                        <ColumnsPickerLite
                            {...getColumnsPickerLiteProps()}
                            withTooltip
                            translations={{
                                tooltip: i18n("workspace.sales.column.picker"),
                                getSelectedAmountText: ({ selectedValue, totalValue }) =>
                                    i18n("common.columnsPicker.selectedAmount", {
                                        selected: selectedValue,
                                        total: totalValue,
                                    }),
                                mandatoryField: i18n("common.columnsPicker.mandatoryField"),
                                apply: i18n("common.apply"),
                            }}
                        />
                    </div>
                    <div>{a2d()}</div>
                </FlexRow>
            </Right>
        </SearchContainer>
    ) : null;
};
